import React, { useMemo, useState } from "react";
import { MESES, hoyISO } from "../utils";

// Calendario con los días que tienen franjas y, al pulsar un día, sus horas.
//   franjas = [{id, fecha, hora_inicio, hora_fin, libres, completa, es_mia}]
//   seleccion = id de la franja elegida   onElegir(franja)
export default function Calendario({ franjas, seleccion, onElegir, deshabilitado }) {
  const porDia = useMemo(() => {
    const m = {};
    franjas.forEach((f) => { (m[f.fecha] = m[f.fecha] || []).push(f); });
    return m;
  }, [franjas]);
  const dias = Object.keys(porDia).sort();
  const inicial = (franjas.find((f) => f.es_mia)?.fecha || dias[0] || hoyISO());
  const [mes, setMes] = useState({ a: +inicial.slice(0, 4), m: +inicial.slice(5, 7) - 1 });
  const [dia, setDia] = useState(franjas.find((f) => f.es_mia)?.fecha || null);
  const hoy = hoyISO();

  const primero = new Date(mes.a, mes.m, 1);
  const huecoInicial = (primero.getDay() + 6) % 7;            // la semana empieza en lunes
  const nDias = new Date(mes.a, mes.m + 1, 0).getDate();
  const celdas = [...Array(huecoInicial).fill(null), ...Array.from({ length: nDias }, (_, i) => i + 1)];
  const iso = (d) => `${mes.a}-${String(mes.m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

  const hayAntes = dias.some((d) => d < `${mes.a}-${String(mes.m + 1).padStart(2, "0")}-01`);
  const hayDespues = dias.some((d) => d > iso(nDias));
  const mover = (n) => { const d = new Date(mes.a, mes.m + n, 1); setMes({ a: d.getFullYear(), m: d.getMonth() }); };

  return (
    <div className="cal">
      <div className="cal-cab">
        <button onClick={() => mover(-1)} disabled={!hayAntes} aria-label="Mes anterior">‹</button>
        <b>{MESES[mes.m]} {mes.a}</b>
        <button onClick={() => mover(1)} disabled={!hayDespues} aria-label="Mes siguiente">›</button>
      </div>
      <div className="cal-grid">
        {["L", "M", "X", "J", "V", "S", "D"].map((s) => <div key={s} className="cal-sem">{s}</div>)}
        {celdas.map((d, i) => {
          if (!d) return <div key={`v${i}`} />;
          const f = iso(d);
          const fr = porDia[f];
          const hayHueco = fr && fr.some((x) => !x.completa || x.es_mia);
          const clase = ["cal-dia", fr ? (hayHueco ? "tiene" : "llena") : "", f === hoy ? "hoy" : "", dia === f ? "sel" : "",
                         fr && fr.some((x) => x.es_mia) ? "mia" : ""].join(" ");
          return <button key={f} className={clase} disabled={!fr} onClick={() => setDia(f)}>{d}</button>;
        })}
      </div>
      {dia && porDia[dia] && (
        <div className="cal-horas">
          {porDia[dia].map((x) => (
            <button key={x.id} className={`cal-hora ${seleccion === x.id ? "sel" : ""} ${x.es_mia ? "mia" : ""}`}
                    disabled={deshabilitado || (x.completa && !x.es_mia)} onClick={() => onElegir(x)}>
              <b>{x.hora_inicio}–{x.hora_fin}</b>
              <small>{x.es_mia ? "tu cita actual" : x.completa ? "completa" : `quedan ${x.libres}`}</small>
            </button>
          ))}
        </div>
      )}
      {!dia && dias.length > 0 && <p className="muted" style={{ marginTop: 10 }}>Pulsa un día marcado en azul para ver las horas.</p>}
      {dias.length === 0 && <p className="muted">Todavía no hay días disponibles. Vuelve a mirar más adelante.</p>}
    </div>
  );
}
